<template>
  <div class="audioCon">
    <div class="audioConListWap">
      <div class="aclwap" v-for="(item,index) in list" :key="index" @click="goDetails(item)">
        <div class="acl_imgs">
          <div class="aclBg">
            <img v-lazy="item.poster" alt="图片"/>
          </div>
          <div class="aclGo">
            <img src="@/assets/playaudio.png" alt />
          </div>
          <!-- <div class="aclnumimg">
            <div class="aclnumimgs">
              <img src="@/assets/ear.png" alt />
            </div>
            <div class="aclnum">123</div>
          </div> -->
        </div>
        <div class="acl_txt" :style="{color:pageSetup.background==1?'#42476C':'#cccccc'}">{{item.name}}</div>
      </div>
    <div style="width:183px;height:0"></div>
    <div style="width:183px;height:0"></div>
    <div style="width:183px;height:0"></div>
    <div style="width:183px;height:0"></div>
    <div style="width:183px;height:0"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {};
  },
  computed: {
        pageSetup() {
            return this.$store.state.pageSetup
        }
    },
  props:{
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    itemClickHandler: {
      type: Function,
      default: undefined
    }
  },
  methods: {
    goDetails(item){
      if (typeof this.itemClickHandler === "function") {
        this.itemClickHandler(item);
        return;
      }

        const { href } = this.$router.resolve({
          path: "/audiosDetails",
          query: { id: item.id }
        });
        window.open(href, '_blank');
      // this.$router.push({path:"/audiosDetails" , query:{ id : item.id}})
    }
  }
};
</script>

<style scoped lang="less">
.audioConListWap {
  display: flex;
  justify-content: space-between;
  flex-wrap:wrap;
  .aclwap {
    width: 183px;
    margin:0 0 20px;
    cursor: pointer;
    .acl_txt {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      // font-weight: 600;
      color: rgba(66, 71, 108, 1);
      line-height: 20px;
      margin-top: 14px;
    }
    .acl_imgs {
      position: relative;
      height: 183px;
      .aclnumimg {
        width: 100%;
        height: 32px;
        background: linear-gradient(
          to right,
          rgba(255, 255, 255, 0),
          rgba(51, 51, 51, 0.6)
        );
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .aclnum {
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: rgba(66, 71, 108, 1);
          color: #fff;
          margin: 0 5px;
        }
        .aclnumimgs {
          width: 25px;
          height: 25px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .aclGo {
        width: 32px;
        height: 32px;
        position: absolute;
        bottom: 20px;
        right: 17px;
        z-index: 1;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .aclBg {
        width: 100%;
        height: 183px;
        background: #b0e0e6;
        position: absolute;
        top: 0;
        left: 0;
        box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        overflow: hidden;
        transition: transform 1.5s;
        img {
          width: 100%;
          height: 100%;
        }
      }
       .aclBg:hover {
        transform:translateY(-10px)
      }
    }
  }
}
</style>
